<div class="metadata-block">
    <!-- Non-editable keys -->
    <div *ngIf="!isEditKeysEnabled; else EditableKeys">
        <div *ngIf="data.key" class="metadata-properties">
            <div class="metadata-key">Key:</div>
            <div class="metadata-value">{{data?.key}}</div>
        </div>
        <div *ngIf="data.fdKey" class="metadata-properties">
            <div class="metadata-key">FDKey:</div>
            <div class="metadata-value">{{data?.fdKey}}</div>
        </div>
        <div *ngIf="data.isoKey" class="metadata-properties">
            <div class="metadata-key">ISOKey:</div>
            <div class="metadata-value">{{data?.isoKey}}</div>
        </div>
    </div>

    <!-- editable keys -->
    <ng-template #EditableKeys>
        <div  *ngIf="isQuestionBuilderPage()">
            <div class="metadata-key">Key:</div>
            <div class="metadata-input-block">
                <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
                <input (keypress)="keyPressAlphaNumeric($event)" id="sectionLabel" class="metadata-input-field"
                    placeholder="HTML Form Key" label="Label" type="text" fxFlex="flex-grow" maxlength="100"
                    [(ngModel)]="data.key" />
            </div>
        </div>
        <div>
            <div class="metadata-key">FDKey:</div>
            <div class="metadata-input-block">
                <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
                <input  (keypress)="keyPressAlphaNumeric($event)" *ngIf="data" (blur)="runOnBlur_FdKey($event)" id="sectionLabel" class="metadata-input-field"
                    placeholder="FlightDeck Key" label="Label" type="text" fxFlex="flex-grow" maxlength="50"
                    [(ngModel)]="data.fdKey" />
            </div>
        </div>
        <div *ngIf="isQuestionBuilderPage()">
            <div class="metadata-key">ISOKey:</div>
            <div class="metadata-input-block">
                <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
                <input (keypress)="keyPressAlphaNumeric($event)" id="sectionLabel" class="metadata-input-field"
                    placeholder="ISO Key" label="Label" type="text" fxFlex="flex-grow" maxlength="50"
                    [(ngModel)]="data.isoKey" />
            </div>
        </div>
    </ng-template>
</div>